import React from 'react';

import { IconButton, Popover, List, ListItem, ListItemText } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        popover: {
            pointerEvents: 'none',
        },
        popoverContent: {
            pointerEvents: 'auto',
            // padding: theme.spacing(2),
        },
        root: {
            width: '100%',
            maxWidth: 360,
            // padding: theme.spacing(2),
            backgroundColor: theme.palette.background.paper,
        },
    })
);

// TODO: remove useless properties
// - childClassName
// - onClickEdit
// - actionsList
// - onClickDelete
// - onClickView
interface VericalPopver_interface {
    childClassName?: string;
    onClickEdit?: () => void;
    onClickAdd?: () => void;
    actionsList?: string;
    styleObj?: any;
    onClickDelete?: () => void;
    onClickView?: () => void;
    viewAction?(): void;
    addAction?(): void;
    editAction?(): void;
    deleteAction?(): void;
    downloadAction?(): void;
}

export const VerticalPopver: React.FC<VericalPopver_interface> = ({
    onClickEdit,
    childClassName,
    actionsList,
    styleObj,
    onClickDelete,
    onClickAdd,
    onClickView,
    viewAction,
    addAction,
    editAction,
    deleteAction,
    downloadAction,
}) => {
    const classes = useStyles();

    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
    const togglePopover = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        event.stopPropagation();
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };
    const open = Boolean(anchorEl);

    const handleAction = (action?: { (): void }) => (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        togglePopover(event);
        event.stopPropagation();
        setAnchorEl(null);
        action && action();
    };

    return (
        <>
            <IconButton
                aria-label="add to favorites"
                aria-owns={open ? 'mouse-over-popover' : undefined}
                aria-haspopup="true"
                onClick={togglePopover}
                className={childClassName}
                style={styleObj && styleObj}
            >
                <MoreVertIcon />
            </IconButton>

            <Popover
                id="mouse-over-popover"
                className={classes.popover}
                classes={{
                    paper: classes.popoverContent,
                }}
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                onClose={togglePopover}
                disableRestoreFocus
                PaperProps={{ onMouseLeave: togglePopover }}
            >
                <List component="nav" className={classes.root} aria-label="contacts">
                    {((actionsList?.split(',').includes('add') && onClickAdd) || addAction) && (
                        <ListItem button onClick={handleAction(onClickAdd || addAction)}>
                            <ListItemText primary="Add" />
                        </ListItem>
                    )}
                    {((actionsList?.split(',').includes('view') && onClickView) || viewAction) && (
                        <ListItem button onClick={handleAction(onClickView || viewAction)}>
                            <ListItemText primary="View" />
                        </ListItem>
                    )}
                    {((actionsList?.split(',').includes('edit') && onClickEdit) || editAction) && (
                        <ListItem button onClick={handleAction(onClickEdit || editAction)}>
                            <ListItemText primary="Edit" />
                        </ListItem>
                    )}
                    {((actionsList?.split(',').includes('delete') && onClickDelete) || deleteAction) && (
                        <ListItem button onClick={handleAction(onClickDelete || deleteAction)}>
                            <ListItemText primary="Delete" />
                        </ListItem>
                    )}
                    {downloadAction && (
                        <ListItem button onClick={handleAction(downloadAction)}>
                            <ListItemText primary="Download" />
                        </ListItem>
                    )}
                </List>
            </Popover>
        </>
    );
};
